import { inject, NewInstance } from 'aurelia-framework';
import { SpecificGravityService } from 'pages/system-fields/specific-gravities/service';
import { CoatingService } from 'pages/system-fields/coatings/service';
import { EventAggregator } from 'aurelia-event-aggregator';
import { DialogService } from 'aurelia-dialog';
import { DialogController } from 'aurelia-dialog';
import { ValidationRules, ValidationController, validateTrigger } from 'aurelia-validation';
import { BootstrapFormRenderer } from 'resources/validation-renderer';
import toastr from 'toastr';

@inject(DialogController, NewInstance.of(ValidationController), SpecificGravityService, EventAggregator, CoatingService, DialogService)
export class SpecificGravityEditor {
    constructor(controller, validationController, specificGravityService, ea, coatingService, dialogService) {
        this.controller = controller;
        this.specificGravityService = specificGravityService;
        this.coatingService = coatingService;
        this.dialogService = dialogService;
        this.ea = ea;
        this.specificGravity = {
            items: []
        };

        this.validationController = validationController;
        this.validationController.validateTrigger = validateTrigger.manual;
        this.validationController.addRenderer(new BootstrapFormRenderer());
        this.rules = ValidationRules
            .ensure('thickness').required()
            .ensure('gravity').required()
            .ensure('coatingId').required()
            .rules;
    }

    async activate(model) {
        if (model?.id != null) {
            this.specificGravity = await this.specificGravityService.getById(model.id);
        }
    } 

    addCoating () {
        this.dialogService.open({ viewModel: this.coatingService.editor });
    }

    addItem () {
        this.specificGravity.items.push({});
    }

    removeItem (index) {
        this.specificGravity.items.splice(index, 1);
    }

    async save() {
        if (this.isRequesting) return;
        this.isRequesting = true;
        const validationResult = await this.validationController.validate();
        if (validationResult.valid) {
            try {
                if (this.specificGravity.id) {
                    await this.specificGravityService.update(this.specificGravity);
                    toastr.success('Specific gravity was updated!');
                } else {
                    await this.specificGravityService.create(this.specificGravity);
                    toastr.success('New specific gravity was created!');
                }
                this.ea.publish('specific-gravities:updated', this.specificGravity);
                this.controller.ok(this.specificGravity);
            } catch {
                this.isRequesting = false;
            }
        }
        this.isRequesting = false;
    }
}